export function getTesterPermissionsFromStorage() {
  try {
    const raw = localStorage.getItem("tester-permissions");
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    return Array.isArray(parsed) ? parsed : null;
  } catch {
    return null;
  }
}

export function testerHasPermission(permission) {
  if (!permission || typeof permission !== "string") return false;
  const perms = getTesterPermissionsFromStorage();
  if (perms === null) return false;
  return perms.includes(permission);
}

export function testerHasAllPermissions(permissions) {
  if (!Array.isArray(permissions) || permissions.length === 0) return false;
  return permissions.every((p) => testerHasPermission(p));
}

export function testerHasAnyPermission(permissions) {
  if (!Array.isArray(permissions) || permissions.length === 0) return false;
  return permissions.some((p) => testerHasPermission(p));
}
